import * as React from 'react';
import {FieldArray} from 'formik';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import {IService, ISystem} from "../../interfaces";
import Service from "./Service";
import {i18n} from "../../config/i18n";

interface Props {
    services: IService[];
    system: ISystem;
    setFieldValue: any;
    submitForm: any;
    locale: string;
    title: string;
    bgColor?: string;
    id: string;
}

const Services: React.FunctionComponent<Props> = props => {
    const {services, setFieldValue, submitForm, bgColor, title, id, system} = props;

    const onDragEnd = (result, move) => {
        const { source, destination } = result;
        if (!destination) return;
        if (
            destination.droppableId === source.droppableId &&
            destination.index === source.index
        )
            return;

        // move code to destination
        move(source.index, destination.index);
        submitForm();
    };

    return (
        <div className="codes_box" id={"services_box_" + id} style={{backgroundColor: bgColor || '#f9f0d7'}}>
            <div className="row">
                <div className="col-sm-12">
                    <h4>{title}
                        <small className="text-secondary ms-2" style={{fontSize: '0.5em'}}>
                            {i18n.t('service_catalog')} {system.catalog_versions.service_catalog}
                        </small></h4>
                </div>
            </div>
            <div>
                <div className="code_input_div row">
                    <div className="col-lg-8 pe-0 text-secondary" style={{fontSize: 8}}>
                        <div className="input-group">
                            <div className="col-sm-3 px-0">
                                Code
                            </div>
                            <div className="col-sm-2 px-0">
                                {i18n.t('service_side')}
                            </div>
                            <div className="col-sm-2 px-0">
                                {i18n.t('tarpo_number')}
                            </div>
                            <div className="col-sm-2 px-0">
                                {i18n.t('session_number')}
                            </div>
                            <div className="col-sm-3 px-0">
                                {i18n.t('service_date')}
                            </div>

                        </div>
                    </div>
                </div>
                <FieldArray
                    name="services"
                    render={arrayHelpers => (
                        <DragDropContext onDragEnd={result => {
                            onDragEnd(result, arrayHelpers.move)
                        }}>
                            <Droppable droppableId="tarpo-dropzone">
                                {(provided) => (
                                    <div
                                        {...provided.droppableProps}
                                        ref={provided.innerRef}
                                    >
                                        {services && services.map((service, index) => (
                                            <Draggable key={index} draggableId={'service' + index} index={index}>
                                                {(provided) => (
                                                    <div
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                    >
                                                        <Service
                                                            index={index}
                                                            service={service}
                                                            setFieldValue={setFieldValue}
                                                            submitForm={submitForm}
                                                            key={index}
                                                            arrayHelpers={arrayHelpers}
                                                            serviceCatalogVersion={system.catalog_versions.service_catalog}
                                                        />
                                                    </div>
                                                )}
                                            </Draggable>
                                        ))}
                                        <div className="row pb-2">
                                            <div className="col-sm-12">
                                                <button
                                                    type="button"
                                                    onClick={() => arrayHelpers.push(
                                                        {
                                                            code: "",
                                                            number: 1,
                                                            active: true,
                                                            sessionNumber: 1,
                                                            date: new Date().toISOString().split('T')[0]
                                                        })}
                                                    className="pull-right btn btn-secondary btn-sm pe-2 ps-2"
                                                >
                                                    <i className="fa fa-plus"/>
                                                </button>
                                            </div>
                                        </div>
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </DragDropContext>
                    )}
                />
            </div>
        </div>
    );
};

export default Services
